import React from "react";
import { useNavigate } from 'react-router-dom';
import styles from "./ConditionsUtilisationPage.module.scss"; // Assurez-vous d'avoir un fichier SCSS correspondant

import Footer from '../../components/Footer/Footer';

const ConditionsUtilisationPage = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1>Conditions d'utilisation du service</h1>

          <hr />
          <section>
            <h2>1. Présentation du service</h2>
            <p>
              L’application <strong>Hatann'App</strong> est une plateforme interactive de jeu de piste permettant aux utilisateurs
              de répondre à des questions en fonction de leur progression sur un itinéraire défini.
              L’utilisation de l’application implique l’acceptation pleine et entière des présentes conditions générales d’utilisation.
            </p>
          </section>

          <section>
            <h2>2. Accès au service</h2>
            <p>
              L’application <strong>Hatann'App</strong> est accessible via un navigateur web sur smartphone ou tout autre appareil compatible.
              L’accès peut être limité en cas de perte de connexion, mais l’application est conçue pour assurer une expérience optimale même en mode hors ligne.
            </p>
          </section>

          <section>
            <h2>3. Création d’un compte</h2>
            <p>
              Certaines fonctionnalités de <strong>Hatann'App</strong> peuvent nécessiter la création d’un compte utilisateur.
              En s’inscrivant, l’utilisateur s’engage à fournir des informations exactes et à maintenir la confidentialité de ses identifiants.
            </p>
          </section>

          <section>
            <h2>4. Utilisation du service</h2>
            <p>L’utilisateur s’engage à :</p>
            <ul>
              <li>Ne pas utiliser <strong>Hatann'App</strong> à des fins frauduleuses ou illégales.</li>
              <li>Ne pas perturber le bon fonctionnement du service.</li>
              <li>Respecter les autres participants du jeu de piste.</li>
            </ul>
          </section>

          <section>
            <h2>5. Propriété intellectuelle</h2>
            <p>
              Tous les éléments de l’application <strong>Hatann'App</strong>, y compris le contenu, les images et le code, sont protégés par les lois sur la propriété intellectuelle
              et ne peuvent être reproduits, modifiés ou diffusés sans autorisation préalable.
            </p>
          </section>

          <section>
            <h2>6. Protection des données personnelles</h2>
            <p>
              <strong>Hatann'App</strong> collecte certaines données pour améliorer l’expérience utilisateur. Ces données sont traitées
              conformément à notre <a className={styles.link} onClick={() => navigate("/privacy")} rel="noopener noreferrer">politique de confidentialité</a>.
            </p>
          </section>

          <section>
            <h2>7. Responsabilité</h2>
            <p>
              L’éditeur de <strong>Hatann'App</strong> ne pourra être tenu responsable en cas de :
            </p>
            <ul>
              <li>Mauvaise utilisation du service par l’utilisateur.</li>
              <li>Problèmes techniques indépendants de notre volonté (panne de serveur, perte de connexion...).</li>
              <li>Contenu généré par les utilisateurs eux-mêmes.</li>
            </ul>
          </section>

          <section>
            <h2>8. Modification des conditions</h2>
            <p>
              L’éditeur se réserve le droit de modifier ces conditions d’utilisation à tout moment.
              Les utilisateurs seront informés des mises à jour via <strong>Hatann'App</strong>.
            </p>
          </section>

          <section>
            <h2>9. Contact</h2>
            <p>
              Pour toute question relative aux présentes conditions, vous pouvez nous contacter à l’adresse suivante&nbsp;:&nbsp; 
              <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a>
            </p>
          </section>

          <section>
            <h2>10. Développement</h2>
            <p>
              Cette application a été développée par <strong>Scriptales SAS</strong> (<a className={styles.link} href="https://scriptales.fr" target="_blank" rel="noopener noreferrer">scriptales.fr</a>).
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ConditionsUtilisationPage;
